import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]
  static values = {
    interval: { type: Number, default: 5000 },
    autoplay: { type: Boolean, default: true }
  }

  connect() {
    this.currentIndex = 0
    this.direction = "next"
    this.showSlide(this.currentIndex, false)

    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  disconnect() {
    this.stopAutoplay()
  }

  startAutoplay() {
    this.stopAutoplay()
    this.autoplayTimer = setInterval(() => {
      this.next()
    }, this.intervalValue)
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
      this.autoplayTimer = null
    }
  }

  next() {
    this.direction = "next"
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
    this.showSlide(this.currentIndex, true)
  }

  prev() {
    this.direction = "prev"
    this.currentIndex = (this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(this.currentIndex, true)
  }

  goTo(event) {
    const newIndex = parseInt(event.currentTarget.dataset.index)
    this.direction = newIndex > this.currentIndex ? "next" : "prev"
    this.currentIndex = newIndex
    this.showSlide(this.currentIndex, true)

    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  showSlide(index, animate = true) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        // Показываем новый слайд
        slide.classList.remove("hidden")
        slide.style.zIndex = "2"

        if (animate) {
          // Начальная позиция (за пределами экрана)
          if (this.direction === "next") {
            slide.style.transform = "translateX(100%)"
          } else {
            slide.style.transform = "translateX(-100%)"
          }

          // Принудительно применяем начальную позицию
          slide.offsetHeight

          // Добавляем transition
          slide.style.transition = "transform 0.5s ease-in-out"

          // Анимация к центру
          requestAnimationFrame(() => {
            slide.style.transform = "translateX(0)"
          })
        } else {
          slide.style.transform = "translateX(0)"
          slide.style.transition = "none"
        }
      } else if (!slide.classList.contains("hidden")) {
        // Скрываем предыдущий слайд
        slide.style.zIndex = "1"

        if (animate) {
          slide.style.transition = "transform 0.5s ease-in-out"

          // Анимация за пределы экрана
          if (this.direction === "next") {
            slide.style.transform = "translateX(-100%)"
          } else {
            slide.style.transform = "translateX(100%)"
          }

          // Скрываем после завершения анимации
          setTimeout(() => {
            if (i !== this.currentIndex) {
              slide.classList.add("hidden")
              slide.style.transform = ""
              slide.style.transition = ""
            }
          }, 500)
        } else {
          slide.classList.add("hidden")
          slide.style.transform = ""
          slide.style.transition = ""
        }
      }
    })

    // Обновляем индикаторы
    this.indicatorTargets.forEach((indicator, i) => {
      if (i === index) {
        indicator.classList.add("status-primary")
      } else {
        indicator.classList.remove("status-primary")
      }
    })
  }

  pauseAutoplay() {
    this.stopAutoplay()
  }

  resumeAutoplay() {
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }
}
